import { ItemType } from "@core/FileStructue/Item/ItemType";
import { isGroupNode } from "@ext/navigation/catalog/SidebarNavigation/utils/isGroupNode";
import type { CategoryLink, ItemLink } from "../../extensions/navigation/NavigationLinks";

const flatten = (itemLinks: ItemLink[]): ItemLink[] =>
	itemLinks.flatMap((link) => {
		if (link.type === ItemType.article) return link;
		const children = flatten((link as CategoryLink).items);
		return isGroupNode(link) ? children : [link, ...children];
	});

const UiUrlUtils = {
	getArticleLinks(itemLinks: ItemLink[]): ItemLink[] {
		const seen = new Set<string>();
		return flatten(itemLinks).filter((link) => {
			const path = link.ref?.path;
			if (!path) return true;
			if (seen.has(path)) return false;
			seen.add(path);
			return true;
		});
	},
};

export default UiUrlUtils;
